import { CollectionImage } from '~/components/collections';
import { NotificationText } from '../NotificationText';
import { StyledNotificationContainer } from './CounterNotification.styled';

const CounterNotification = ({
	text,
	count,
	image,
	...props
}: {
	text: string;
	count: number;
	image?: string;
	$layerIndex?: number;
} & React.HTMLAttributes<HTMLDivElement>) => {
	return (
		<StyledNotificationContainer {...props}>
			<CollectionImage collection={'items'} id={image ?? ''} size={20} />
			<NotificationText $color={'black'}>
				{text} <span style={{ opacity: 0.5 }}>(x{count})</span>
			</NotificationText>
		</StyledNotificationContainer>
	);
};

export { CounterNotification };
